<template>
  <!-- 简历 -->
  <div class="detail__wrapDrawer" v-show="visible">
    <div class="top-title">
      <div>
        <i
          class="el-icon-close cursor"
          style="font-size: 18px"
          @click="toggle(false)"
        ></i>
      </div>
    </div>
    <div class="main section_Drawer shadow jianli">
      <div class="section_Drawer">
        <div class="flex">
          <div>
            <el-image
              ref="preview"
              class="picture"
              style="width: 100px; height: 100px; border-radius: 5px"
              :src="userInfo.avatar"
              :preview-src-list="[userInfo.avatar]"
              fit="cover"
            >
              <div slot="error" class="image-slot">
                <img
                  :src="require('@/assets/img/default1.png')"
                  style="width: 100px; height: 100px; border-radius: 5px"
                />
              </div>
            </el-image>
          </div>
          <div style="display: flex; justify-content: space-between; flex: 1">
            <div class="user-info">
              <div class="userName">
                <div class="userName-left">
                  <div class="name">
                    {{ userInfo.nickname }}
                  </div>
                  <div class="sex">
                    {{
                      userInfo.sex === 0
                        ? "未填"
                        : userInfo.sex === 1
                        ? "男"
                        : "女"
                    }}
                  </div>
                  <el-image
                    style="width: 50px; margin-right: 6px"
                    v-if="userInfo.is_honesty == 1"
                    :src="require('@/assets/img/chengxinbaoPlus.png')"
                  ></el-image>
                  <el-image
                    style="width: 50px; display: flex; justify-content: center"
                    v-if="userInfo.is_honesty == 2 && userInfo.is_vip == 1"
                    :src="require('@/assets/img/vip.png')"
                  ></el-image>
                  <el-image
                    style="
                      width: 50px;
                      margin-left: 6px;
                      display: flex;
                      justify-content: center;
                    "
                    v-if="userInfo.pass_user_auth == 1"
                    :src="require('@/assets/img/mxrz.png')"
                  ></el-image>
                </div>
              </div>
              <div class="degree">
                <span>{{ userInfo.age }}岁</span>
                <!-- <span>{{ userInfo.city_name || "无" }}</span> -->
                <span>{{ userInfo.major || "无" }}</span>
                <span>{{ userInfo.education || "无" }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="phone-email-box">
          <div class="phone-email">
            <div>
              <i class="el-icon-mobile-phone"></i>
              <span style="margin-left: 6px">{{
                userInfo.mobile || "无"
              }}</span>
            </div>
            <div style="margin-left: 20px">
              <i class="el-icon-message"></i>
              <span style="margin-left: 6px">{{ userInfo.email || "无" }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="section_Drawer mt50">
        <p class="title fontB">教育经历</p>
        <div>
          <p class="fs16">{{ userInfo.school }}</p>
          <p>{{ userInfo.major }}</p>
          <p v-if="userInfo.school_start">
            {{ userInfo.school_start }} - {{ userInfo.school_end }}
          </p>
        </div>
      </div>
      <div class="section_Drawer mt50">
        <p class="title fontB">自我评价</p>
        <p class="text">{{ userInfo.evaluate || "无" }}</p>
      </div>
      <div class="section_Drawer mt50">
        <p class="title fontB">求职意向</p>
        <p>
          <span>工作地点：</span
          ><span class="fs16">{{ userInfo.intention_city_name }}</span>
        </p>
        <p>
          <span>工作岗位：</span
          ><span class="fs16">{{ userInfo.intention_job }}</span>
        </p>
        <p>
          <span>期望薪资：</span
          ><span class="fs16">{{
            userInfo.intention_salary == "0K-0K"
              ? ""
              : userInfo.intention_salary
          }}</span>
        </p>
        <!-- <p>
          <span>工作类型：</span
          ><span class="fs16">{{
            intention_type[userInfo.intention_type]
          }}</span>
        </p> -->
        <p>
          <span>行业类别：</span
          ><span class="fs16">{{ userInfo.intention_category }}</span>
        </p>
      </div>
      <div class="section_Drawer mt50">
        <p class="title fontB">工作/实习经历</p>
        <template v-if="userInfo.work_suffer.length > 0">
          <div
            v-for="(item, index) in userInfo.work_suffer"
            :key="index"
            class="work_suffer"
          >
            <div class="" style="margin-top: 6px">
              <p class="fs16">{{ item.company_name }}</p>
              <p v-if="item.end_time">
                {{ item.start_time }} - {{ item.end_time }}
              </p>
            </div>
            <p class="fs16">
              {{ item.job_name }}
              <!-- <span style="margin-left: 50px">{{
                toStr({ 0: "未填", 1: "全职", 2: "兼职" }, item.type)
              }}</span> -->
              <span style="margin-left: 50px"
                >{{ item.salary_start }}k - {{ item.salary_end }}k</span
              >
            </p>
            <p>{{ item.content }}</p>
          </div>
        </template>
        <template v-else> 无 </template>
      </div>
      <div class="section_Drawer mt50">
        <p class="title fontB">在校经历</p>
        <template v-if="userInfo.school_suffer">
          <div
            v-for="(line, index) in userInfo.school_suffer.split('\n')"
            :key="index"
          >
            {{ line }}
          </div>
        </template>
        <div v-else>无</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "jianli",
  data() {
    return {
      defaultAvator: require("@/assets/img/default1.png"),
      currentRow: null,
      visible: false,
      userInfo: {
        work_suffer: {},
      },
      intention_type: {
        0: "未填",
        1: "全职",
        2: "实习",
      },
      is_recommend: "",
      conversationID: "",
      printLoading: false,
      fromJob_Id: "",
      fromjobName: "",
    };
  },
  methods: {
    init() {
      if (this.conversationID) {
        this.getUserInfo({ conversationID: this.conversationID });
      } else {
        this.getUserInfo(this.currentRow, this.is_recommend);
      }
    },
    getUserInfo(row, is_recommend = 1) {
      let { conversationID = "", job_id = "", job_name = "" } = row;
      this.fromJob_Id = job_id;
      this.fromjobName = job_name;
      this.currentRow = row;
      this.is_recommend = is_recommend;
      let params = {
        id: row.id,
        is_recommend: is_recommend, // 没下载的都传1   下栽过的传0
      };
      this.$http.get("/admin/resume/detail", { params }).then((res) => {
        if (res.code === 1) {
          this.userInfo = res.data;
        }
      });
    },
    reset(done) {
      this.is_recommend = "";
      this.conversationID = "";
      this.userInfo = {
        work_suffer: {},
      };
      done && done();
    },
    toggle(show) {
      this.visible = show;
      if (!show) {
        this.$emit("refresh");
        this.$emit("closeDrawer", show);
      }
      !show && this.reset();
    },
    toStr(data, key) {
      return data[key];
    },
  },
};
</script>

<style scoped lang="scss">
.detail__wrapDrawer {
  z-index: 999 !important;
  overflow-y: scroll;
  padding: 10px;
  // @include position($t: 40px, $r: 0, $b: 0, $l: 0);

  .crumbs__wrap {
    margin-bottom: 20px;
  }

  .main {
    background-color: #fff;
    height: 100%;
    padding: 20px;
  }
}

.flex {
  display: flex;
}
.phone-email-box {
  display: flex;
  justify-content: end;
  padding-right: 40px;
  padding-left: 12px;
}
.phone-email {
  display: flex;
  width: calc(100% - 100px);
}
.mt50 {
  margin-top: 10px;
}
.fs16 {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.jianli {
  background-color: #fff;
  // padding: 20px !important;
  color: #656565;

  .text {
    width: 60%;
    line-height: 30px;
  }
  .title {
    background: url("~@/assets/img/points.png");
    background-repeat: no-repeat;
    background-position-y: 6px;
    padding-left: 30px;
    height: 30px;
    line-height: 30px;
  }
  .picture {
    margin-right: 15px;
  }
  .fontB {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }
  .section_Drawer {
    p {
      margin-bottom: 10px;
    }
    .user-info {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      position: relative;
      .font-bold {
        font-weight: bold;
      }
      .userName-left {
        max-width: 200px;
        display: flex;
        align-items: center;
        .sex {
          width: 20px;
          height: 20px;
          line-height: 20px;
          background: #ffffff;
          border-radius: 4px;
          text-align: center;
          border: 1px solid #ff8ba9;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #ff5c86;
          margin-right: 4px;
        }
        .name {
          flex: 1;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 20px;
          color: #1f1f1f;
          margin-right: 4px;
        }
      }
      .userName {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .task-row {
          display: flex;
          align-items: center;
        }
      }
      .degree span {
        margin-right: 16px;
      }
      .degree span:not(:first-child)::before {
        position: absolute;
        height: 15px;
        width: 2px;
        background-color: #656565;
        margin-top: 2px;
        margin-left: -8px;
        content: "";
      }
    }
    .date {
      height: 30px;
      line-height: 30px;
      background: #0c64c6;
      color: #fff;
      padding: 5px 10px;
      border-radius: 20px 0 0 20px;
      position: absolute;
      right: 20px;
    }
  }
  .work_suffer {
    // margin-top: 30px;
    // border-top: solid 1px #eee;
  }
  .work_suffer:first-child {
    border-top: none;
  }
}
.margin-bottom-10 {
  margin-bottom: 10px;
}
.top-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>